import NavigationService from '@/services/NavigationService'

const service = new NavigationService()

export default service
